import globals from "@/utils/globals";
import { datadogRum } from "@datadog/browser-rum";

const {
  applicationId, clientToken
} = globals.datadog || {};

let initialized = false;

const init = () => {
  datadogRum.init({
    applicationId: applicationId,
    clientToken: clientToken,
    site: "datadoghq.com",
    service: "Web",
    env: location.hostname. includes("www.blinkist.com") ? "production" : "development",
    sampleRate: 100, // 100  = 100% of all session are being sent to datadog - might reduce in the future to save data quota
    trackInteractions: true,
    allowedTracingOrigins: [/https:\/\/(www-dev|www)\.blinkist\.com/]
  });
  initialized = true;
};

export const attachUserInfoToDataDog = (fingerprint, userId) => {
  if (!initialized) return;

  datadogRum.setUser({ id: userId });
  datadogRum.addRumGlobalContext("fingerprint", fingerprint);
};

// See also: https://docs.datadoghq.com/real_user_monitoring/browser/collecting_browser_errors/?tab=npm
export const reportError = (error) => {
  if (!initialized) return;

  datadogRum.addError(error, undefined, "custom");
};

// See also: https://docs.datadoghq.com/real_user_monitoring/browser/tracking_user_actions/?tab=npm
export const reportAction = (name, payload) => {
  if (!initialized) return;

  datadogRum.addAction(name, payload);
};

if (applicationId && clientToken) {
  init();
}
